import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import TVPricingItemsBlockData from 'app/Models/Content/TVPricingItemsBlockData';
import React from 'react';
import {Container} from 'reactstrap';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';

const TVPricingItemsBlock = (props: ComponentProps<TVPricingItemsBlockData>) => {
  const {data, context} = props;
  return (
    <BlockWrapper props={props}>
      <div className='TVPricingItemsBlock'>
        <Container className='TVPricingItemsBlock__container'>
          <div className='TVPricingItemsBlock__container__items'>
            <ContentArea noWrap context={context} data={data.operationBoxItems} />
          </div>
        </Container>
      </div>
    </BlockWrapper>
  );
};

export default TVPricingItemsBlock;
